import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const OffersRoutes: Routes = [
  {
    path: "offers",
    loadComponent: () =>
      import("./offers/offers.component").then((m) => m.OffersComponent),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./offer-list/offer-list.component").then(
            (m) => m.OfferListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./offers-form/offers-form.component").then(
            (m) => m.OffersFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./offers-form/offers-form.component").then(
            (m) => m.OffersFormComponent,
          ),
      },
    ],
  },
];
